module.exports = __webpack_public_path__ + "media/images/icons/note-b821e6022431dc9e1e6aaff0b52429d0.svg";